module.exports = __webpack_public_path__ + "img/anon.4f206e87.png";